import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SegmentSubCategory = {
	name: NAME,
	apiProvider,
	router,
};
